// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__container-JZModq","networkContainer":"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__networkContainer-DqjOHE","rightContainer":"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__rightContainer-LAoRAd","leftContainer":"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__leftContainer-hFeQip","statusText":"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__statusText-Mj7KTL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__container-JZModq\",\"networkContainer\":\"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__networkContainer-DqjOHE\",\"rightContainer\":\"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__rightContainer-LAoRAd\",\"leftContainer\":\"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__leftContainer-hFeQip\",\"statusText\":\"src-domain-components-logical-device-sim-information-logicalDeviceSIMInformation-module__statusText-Mj7KTL\"}";
        // 1792611263526
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  